import { env } from './env';

/**
 * Build-time constants injected by Vite (`define` in vite.config.ts).
 * Declared in src/types/global.d.ts.
 */
const buildInfo = {
  version: __APP_VERSION__,
  commit: __APP_COMMIT__,
  builtAt: __APP_BUILT_AT__,
} as const;

export const appConfig = {
  name: 'OTrack',

  api: {
    /**
     * Origin only, empty for same-origin.
     *
     * Deliberately carries no `/api/v1` prefix. The OpenAPI spec declares its server as `/`,
     * so every generated endpoint path already starts with `/api/v1/...`; adding it here too
     * produced `/api/v1/api/v1/vendor/orders` and a 401 from the security chain, which never
     * matched that path. Hand-written paths (the axios downloads) spell the prefix out in
     * full for the same reason - one rule for every call, not two.
     */
    baseUrl: env.VITE_API_BASE_URL,
    timeoutMs: env.VITE_REQUEST_TIMEOUT_MS,
  },

  build: buildInfo,

  environment: env.VITE_ENVIRONMENT,

  /**
   * Shown as a badge in the header everywhere except production. Staging and production look
   * identical otherwise, and "which environment am I actually looking at" is exactly the
   * question that precedes someone refunding a real customer from a test console.
   */
  showEnvironmentBadge: env.VITE_ENVIRONMENT !== 'production',

  ui: {
    sidebarWidth: 264,
    sidebarCollapsedWidth: 64,
    /** Matches the backend's PageRequestForm default. */
    defaultPageSize: 50,
    searchDebounceMs: 300,
  },
} as const;

export type AppConfig = typeof appConfig;
